import Vue from 'vue'

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -150,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

//////////////////////////////////////////////////////////////// Bootstrap Modal
import {
    ModalPlugin
} from 'bootstrap-vue'
Vue.use(ModalPlugin)

//////////////////////////////////////////////////////////////// Gallery Lightbox
import {
    galleryOptions
} from './imports/fancyOptions'
import FancyBox from './plugins/fancy-box/index.js'
Vue.use(FancyBox, galleryOptions)

//////////////////////////////////////////////////////////////// Form validation
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS

//////////////////////////////////////////////////////////////// Sticky Header
import StickyElement from './components/sticky-element/index.vue'
Vue.component('sticky-element', StickyElement)

//////////////////////////////////////////////////////////////// Background Image
import BgImage from './components/bg-image/index.vue'
Vue.component('BgImage', BgImage)

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES

//////////////////////////////////////////////////////////////// Gsap
import Gsap from './directives/gsap/index.js'
Vue.directive('Gsap', Gsap)

/////////////////////////////////////////////////////////////////////////////////////////////////// FILTERS

//////////////////////////////////////////////////////////////// Currency
import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter, [{
        name: 'currency',
        symbol: '€',
        thousandsSeparator: '.',
        fractionCount: 2,
        fractionSeparator: ',',
        symbolPosition: 'back',
        symbolSpacing: false,
        avoidEmptyDecimals: '',
    },
    {
        name: 'currencynosymbol',
        symbol: '',
        thousandsSeparator: '.',
        fractionCount: 2,
        fractionSeparator: ',',
        symbolPosition: 'back',
        symbolSpacing: false,
        avoidEmptyDecimals: '',
    }
])

/////////////////////////////////////////////////////////////////////////////////////////////////// APP

//////////////////////////////////////////////////////////////// Shop
import Store from './shop/store.js'

//////////////////////////////////////////////////////////////// Cart
const TheCart = () => import('./shop/cart/the-cart.js')

//////////////////////////////////////////////////////////////// Checkout
const CheckoutForm = () => import('./shop/checkout/checkout-form.js')
const EnquiryForm = () => import('./shop/checkout/enquiry-form.js')

//////////////////////////////////////////////////////////////// Products
const AddToCart = () => import('./shop/products/add-to-cart.js')

//////////////////////////////////////////////////////////////// Local
const TourCarousel = () => import('./tour-carousel.vue')

new Vue({
    el: '#app',
    store: Store,
    components: {
        TheCart,
        AddToCart,
        TourCarousel,
        CheckoutForm,
        EnquiryForm
    },
    data() {
        return {
            lang: document.getElementById('app').getAttribute('lang'),
            headerUnpinned: false
        }
    },
    created() {
        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;')
    },
})